import styles from "../../Dashboard.module.css";
import { grantStatus } from "../../../../../utils/Enums/grantStatus";

const CalendarGrid = ({ selectedDay, dias, getDayRegister, calendarData, handleSelectDay, ano, mes}) => {
    return (
        <>
            {["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"].map((dia) => (
                <div key={dia} className={styles.calendarWeekHeader}>
                    {dia}
                </div>
            ))}

            {dias.map((dia, index) => {
                if (!dia) return <div key={`empty-${index}`} />;

                const register = getDayRegister(calendarData, dia);
                const status = register?.status;
                const hasViolation = register?.violacoes?.length;
                const isWorkingOutOfSchedule = (status == 6 || status == 7);
                const today = new Date();
                const currentDate = new Date(ano, mes - 1, dia);
                const isFutureDay = currentDate > today;
                const isStatusDisabled = !status;
                const isDisabled = isFutureDay || isStatusDisabled;

                return (
                    <div
                        key={dia}
                        onClick={() => {
                            if (!isDisabled) handleSelectDay(dia);
                        }}
                        className={`
                                    ${styles.calendarDay}
                                    ${hasViolation || isWorkingOutOfSchedule ? styles.calendarViolation : ""}
                                    ${dia === selectedDay ? styles.calendarSelected : ""}
                                    ${currentDate.toDateString() === today.toDateString() ? styles.calendarToday : ""}
                                    ${isDisabled ? styles.calendarDisabled : ""}
                                `}
                    >
                        <div className={styles.calendarDayNumber}>
                            {dia}
                        </div>

                        {hasViolation ? (
                            <div className={styles.calendarDayViolationsContainer}>
                                {isWorkingOutOfSchedule && (
                                    <div className={styles.calendarViolationText}>
                                        {grantStatus[status]}
                                        <hr />
                                    </div>
                                )}
                                {register.violacoes.map((violacao, i) => (
                                    <div key={i} className={styles.calendarViolationText}>
                                        {violacao.descricao}
                                    </div>
                                ))}
                                <div className={styles.calendarRedDot} />
                            </div>
                        ) : (
                            (!isFutureDay && !isWorkingOutOfSchedule) ? (
                                <div className={styles.calendarDayOk}>
                                    OK
                                </div>
                            ) : (
                                <div className={styles.calendarDayViolationsContainer}>
                                    {grantStatus[status]}
                                </div>
                            )
                        )}
                    </div>
                );
            })}
        </>
    );
}

export default CalendarGrid;